export default __webpack_public_path__ + "9929315d8eb745874bead6866db2bd0e.png";